import { createEffect } from 'solid-js'
import { useParams } from '@solidjs/router'
import { getPartnerConfig } from '../data/static/partner-config.js'
import { useLocaleNavigate } from '../utils/locale-navigation.js'
import { usePartner } from '../contexts/partner-context.jsx'

/**
 * Validates `:partnerSlug` from the URL, syncs {@link usePartner} context, and renders children.
 * Unknown slugs redirect to `/not-found` (locale-aware).
 */
export default function PartnerRouteWrapper (props) {
    const parameters = useParams()
    const navigate = useLocaleNavigate()
    const {
        clearPartnerConfig,
        setPartnerConfig,
    } = usePartner()

    createEffect(() => {
        const partnerSlug = parameters.partnerSlug
        const config = getPartnerConfig(partnerSlug)
        if (!config) {
            clearPartnerConfig()
            navigate('/not-found', {
                replace: true,
            })
            return
        }
        setPartnerConfig(config)
    })

    return props.children
}
